import $ from 'jquery';

export function cleanHtml(data){
    var html= $.parseHTML(data);
    return $(html).text();
};

export function cleanTitle(title){ 
    return cleanHtml(title.substr(-1)===":"? title.substr(0,title.length-1) : title);
};